import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/logo_dentisan.png";
import styles from "./Header.module.css";

export default function Header() {
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);

    const handleLinkClick = () => setMenuOpen(false);

    return (
        <header className={styles.header}>
            <div className={styles.container}>
                {/* Logo como enlace a /Inicio */}
                <Link to="/Inicio" onClick={() => setMenuOpen(false)}>
                    <img src={logo} alt="Logo" className={styles.logoHeader} />
                </Link>

                <button
                    className={styles.burger}
                    aria-label="Toggle menu"
                    aria-expanded={menuOpen}
                    onClick={() => setMenuOpen(!menuOpen)}
                    type="button"
                >
                    <span className={menuOpen ? styles.burgerLineOpen : styles.burgerLine}></span>
                    <span className={menuOpen ? styles.burgerLineOpen : styles.burgerLine}></span>
                    <span className={menuOpen ? styles.burgerLineOpen : styles.burgerLine}></span>
                </button>

                <nav className={`${styles.navegacion} ${menuOpen ? styles.active : ""}`}>
                    <Link
                        className={`${styles.menu} ${location.pathname === "/Inicio" ? styles.activeLink : ""}`}
                        to="/Inicio"
                        onClick={handleLinkClick}
                    >
                        Inicio
                    </Link>
                    <Link
                        className={`${styles.menu} ${location.pathname === "/Nosotros" ? styles.activeLink : ""}`}
                        to="/Nosotros"
                        onClick={handleLinkClick}
                    >
                        Nosotros
                    </Link>
                    <Link
                        className={`${styles.menu} ${location.pathname === "/Servicios" ? styles.activeLink : ""}`}
                        to="/Servicios"
                        onClick={handleLinkClick}
                    >
                        Servicios
                    </Link>
                    <Link
                        className={`${styles.menu} ${location.pathname === "/Contacto" ? styles.activeLink : ""}`}
                        to="/Contacto"
                        onClick={handleLinkClick}
                    >
                        Contacto
                    </Link>
                </nav>
            </div>
        </header>
    );
}
